/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import FaceMatch from "./FaceMatch.container";

export default FaceMatch;
